var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay"},[_c('div',{staticClass:"title"}),_c('vue-qr',{attrs:{"correctLevel":3,"autoColor":false,"download":_vm.downloadFilename,"text":_vm.url,"logoSrc":_vm.imageUrl,"size":200,"margin":0,"logoMargin":3}}),_c('p',{staticClass:"paymoney"},[_vm._v("支付金额："+_vm._s(_vm.$route.query.amount)+"元")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }